define([
        'jQuery',
        'underscore',
        'library/fcse-locationwidget/locationWidget',
        'library/fcse-compatibility/object'],
    function ($, _, LocationWidget, Object) {

        var DestinationWidgetExtended = function (element, options) {
            // Call Constructor of parent class
            LocationWidget.apply(this, arguments);

            var defaultOptions = {
                labelCountPrefix: this.element.data('label-count-prefix')
            };

            // Add default options and custom options
            this.addOptions(defaultOptions, options);

            // Regsiter All Locations Click Event
            this._registerAllLocationsClickEvent();
        };

        DestinationWidgetExtended.prototype = $.extend(Object.create(LocationWidget.prototype), {
            // All Locations Click Handler
            _registerAllLocationsClickEvent: function () {
                $('[data-fcse-role="locationwidget--alllocations"]', this.element).on('click', $.proxy(this._allLocationsClickEvent, this));
            },

            _allLocationsClickEvent: function () {
                // Un-Check all other checkboxes
                $('[data-fcse-role="locationwidget--mainoption"], [data-fcse-role="locationwidget--option"]')
                    .find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);

                // Remove-Tags
                var tagBar = $('[data-fcse-role="locationwidget--tagbar"]', this.element);
                tagBar.find('[data-fcse-role="locationwidget--tagitem"]').remove();

                // Show Default value of Tagbar and Check AllLocations-Checkbox
                this._showHideTagsPrompt();
            },

            // Override RegisterOptionsClickEvent
            _registerOptionsClickEvent: function () {
                var self = this;

                $('[data-fcse-role="locationwidget--mainoption"], [data-fcse-role="locationwidget--option"]',
                    this.element).on("click", function (e) {
                    var $this = $(this);
                    var cbx = $('[data-fcse-role="locationwidget--cbx"]:first', $this);
                    var isCbx = $(e.target).is('[data-fcse-role="locationwidget--cbx"]');
                    var isChecked = isCbx ? cbx.is(':checked') : !cbx.is(':checked');
                    var isMainSelected = false;

                    if (!isCbx) {
                        return;
                    }

                    if ($this.is('[data-fcse-role="locationwidget--mainoption"]')) {
                        var checkSubCheckboxes;
                        if ($this.find('[data-fcse-role="locationwidget--cbx"]:first').is(':checked')) {
                            checkSubCheckboxes = true;
                        } else {
                            checkSubCheckboxes = false;
                        }

                        // Check/Un-Check all options every time mainoption is clicked.
                        self._getContentElement('data-group-id', $this.data('id'))
                            .find('[data-fcse-role="locationwidget--cbx"]').each(function (i, item) {
                            $(item).prop('checked', checkSubCheckboxes);
                        });

                    } else {
                        var mainCheckbox = $('[data-fcse-role="locationwidget--mainoption"][data-id="' +
                            $this.data('group-id') + '"] [data-fcse-role="locationwidget--cbx"]:first',
                            self.element);
                        isMainSelected = mainCheckbox.is(':checked');

                        if (isMainSelected) {
                            // Un-Check MainCheckbox of clicked Checkbox
                            mainCheckbox.prop('checked', false);
                            self._removeTag($this.data('group-id'));
                            isMainSelected = false;

                            // Un-Check clicked Checkbox
                            cbx.prop('checked', false);

                            // Add Tags for all active elements
                            self._getContentElement('data-group-id', $this.data('group-id'))
                                .find('[data-fcse-role="locationwidget--cbx"]:checked')
                                .each(function (i, item) {
                                    self._addTag($(item).closest('[data-fcse-role="locationwidget--option"]')
                                        .data('id'));
                                });

                            e.preventDefault();
                        }
                    }

                    if (!isMainSelected) {
                        (isChecked) ? self._addTag($this.data('id')) : self._removeTag($this.data('id'));
                    }
                    e.stopPropagation();
                });

                $('[data-fcse-role="locationwidget--mainoption"] .list-main-option', this.element).on("click", function (e) {
                    var $this = $(this);
                    var $target = $(e.target);

                    if ($target.is('.list-sub-option') || $target.parents('.list-sub-option').length) {
                        return;
                    }

                    var isCbx = $(e.target).is('[data-fcse-role="locationwidget--cbx"]');
                    var list = $this.find('.list-checkbox--option');
                    var icon = $this.find('.icon');

                    if (!isCbx) {
                        list.toggle();
                        icon.toggleClass('icon-arrow-bottom icon-arrow-top');
                    } else {
                        var cbx = $('[data-fcse-role="locationwidget--cbx"]:first', $this);
                        var isChecked = isCbx ? cbx.is(':checked') : !cbx.is(':checked');

                        if (isChecked) {
                            list.show();
                            icon.removeClass('icon-arrow-bottom').addClass('icon-arrow-top');
                        }
                    }
                });
            },

            // Override RegisterRemoveFromTabBarClickEvent
            _registerRemoveFromTagBarClickEvent: function () {
                var self = this;

                $('[data-fcse-role="locationwidget--tagbar"]', this.element).on('click',
                    '[data-fcse-role="locationwidget--tagitemremovebtn"]', function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        var id = $(this).closest('[data-tag-id]').data('tag-id');

                        // Un-Check Checkbox from directly related element
                        self._getContentElement('data-id', id)
                            .find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);

                        // Un-Check Checkbox from elements, that are part of the related group
                        self._getContentElement('data-group-id', id)
                            .find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false)

                        // Remove Tag
                        self._removeTag(id);
                    });
            },

            // Override ShowHideTagsPrompt
            _showHideTagsPrompt: function () {
                var defaultTag = $('[data-fcse-role="locationwidget--defaulttagitem"]', this.element);

                if (!$('[data-fcse-role="locationwidget--tagitem"]', this.element)
                        .filter(':not([data-tag-id="{TAG_ID}"])').length) {
                    // Show Default-Tag
                    defaultTag.show();

                    // Check All Locations-Checkbox
                    $('[data-fcse-role="locationwidget--alllocations"]', this.element)
                        .find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
                } else {
                    // Hide Default-Tag
                    defaultTag.hide();

                    // Un-Check All Locations-Checkbox
                    $('[data-fcse-role="locationwidget--alllocations"]', this.element)
                        .find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
                }
            },

            // Set Value To UI
            setValueToUi: function () {
                var self = this;
                var valueArray = this.value;

                $('[data-fcse-role="locationwidget--tagitem"]', this.element).filter(':not([data-tag-id="{TAG_ID}"])').remove();

                $('[data-fcse-role="locationwidget--cbx"]', this.element).each(function (i, item) {
                    $(item).prop('checked', false);
                });

                _.each(valueArray, function (value, key) {
                    var options = self._getContentElement('data-value', value);

                    options.find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);


                    _.each(options, function (item) {
                        var $item = $(item);
                        // If Main-Option is selected, all other Sub-Checkboxes must be also checked
                        if ($item.attr('data-fcse-role') == 'locationwidget--mainoption') {
                            $item.parent()
                                .find('[data-fcse-role="locationwidget--option"][data-group-id="' +
                                    $item.data('id') + '"]')
                                .find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
                        }
                    });

                    self._addTag(options.data('id'));
                });

                this._showHideTagsPrompt();
            },

            // Override FormatValue
            formatValue: function () {
                if (!_.isUndefined(this.getValue()) && this.getValue().length > 1) {
//                        var count = 0;
//                        
//                        // Count elements
//                        $.each(this.getValue(), function(index, item) {
//                            var $item = $('[data-value="'+item+'"]', this.element);
//                            var groupElements = $('[data-fcse-role="locationwidget--option"][data-group-id="'+
//                                              $item.data('id') +'"]', this.element);                            
//                            
//                            if(groupElements.length >= 1) { // Is Main-Option
//                                count = count + groupElements.length;
//                            } else { // Is single Option
//                                count++;
//                            }
//                        });

                    var labelCountPrefix = this.option('labelCountPrefix');
                    if (labelCountPrefix.length >= 1) {
                        labelCountPrefix += " ";
                    }
                    return labelCountPrefix + this.getValue().length + " " + this.option('labelCount');
                } else if (_.isUndefined(this.getValue()) || this.getValue().length == 0) {
                    return this.option('labelNoCount');
                } else {
                    return this._getContentElement('data-value', this.getValue()[0]).data('name');
                }
            }
        });

        return DestinationWidgetExtended;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/destination/destinationWidgetExtended.js